import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { IMyDpOptions } from 'mydatepicker';
import { saveAs } from 'file-saver';

import * as moment from 'moment';
import 'moment/locale/pt-br';

// Services
import { MonitorService } from '../service/monitor.service';
import { Observable, Subscription } from "rxjs/Rx";

@Component({
	selector: 'monitor',
	templateUrl: './monitor.component.html',
	styleUrls: ['./monitor.scss'],
	providers: [
		MonitorService,
		HttpModule
	]
})
export class MonitorComponent implements OnInit {

	private token;
	private sub: any;
	private today = moment().format("YYYY-MM-DD HH:mm:ss");
	public permissoes: any[] = [];
	public statusService: object;
	public quantitys: object;
	public volumes: object;
	public errorMessages: any[] = [];
	public period: string = '24';
	public specificPeriodStart: string;
	public specificPeriodEnd: string;
	public hoursStart: string = '00:00';
	public hoursEnd: string = '00:00';
	public selectedPeriod: string;
	public ovPeriodStart: string;
	public ovPeriodEnd: string;
	public ovNumber: string;
	public ovNotifications: any[] = [];
	public ovSend: any[] = [];
	public ovErrorMessages: any[] = [];
	public hourMask = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
	public automaticRefresh: boolean = false;
	public timerSubscription: Subscription;
	public autoRefreshTime: number = 30;
	public timer: any = Observable.interval(this.autoRefreshTime * 1000);

	private periodDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	private periodOvDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	public tableChartData = {
		chartType: 'LineChart',
		dataTable: [],
		options: {
			height: 500,
			chart: {
				title: '',
				subtitle: ''
			},
			series: {
				0: { targetAxisIndex: 0 },
				1: { targetAxisIndex: 1 }
			},
			title: '',
			vAxes: {
				// Adds titles to each axis.
				0: { title: 'Minutos', slantedText: true, slantedTextAngle: 45 },
				1: { title: 'DRs', slantedText: true, slantedTextAngle: 45 },
			},
			animation:{
			  duration: 1000,
			  easing: 'out',
			  startup: true
			}
		}
	};

	constructor(fb: FormBuilder, private monitorService: MonitorService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getStatus();
		this.getQuantitys();
		this.getByPeriod(false);
	}

	ngOnDestroy() {
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}

	validateTime(hour) {
		if (hour === 'start') {
			var hours = this.hoursStart.split(":");
			if (Number(hours[0]) > 24) {
				this.hoursStart = "24" + ":" + hours[1];
			}
		} else if (hour === 'end') {
			var hours = this.hoursEnd.split(":");
			if (Number(hours[0]) > 24) {
				this.hoursEnd = "24" + ":" + hours[1];
			}
		}
	}

	getStatus() {
		this.monitorService.getStatus().subscribe(result => {
			if (result.Success) {
				this.statusService = result.Result;
				console.log("this.statusService", this.statusService);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getQuantitys() {
		this.monitorService.getQuantitys().subscribe(result => {
			if (result.Success) {
				this.quantitys = result.Result;
				console.log("this.quantitys", this.quantitys);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getByPeriod(exportExcel) {
		let period = Number(this.period);
		let start = "";
		let end = "";
		let dates: object = {
			dataInicio: '',
			dataFim: ''		
		};

		if (period === 0) {
			this.selectedPeriod = "Período Específico";
			start = this.specificPeriodStart ? this.specificPeriodStart['date']['year'] + "-" + this.specificPeriodStart['date']['month'] + "-" + this.specificPeriodStart['date']['day'] + " " + this.hoursStart : null;
			end = this.specificPeriodEnd ? this.specificPeriodEnd['date']['year'] + "-" + this.specificPeriodEnd['date']['month'] + "-" + this.specificPeriodEnd['date']['day'] + " " + this.hoursEnd : null;
			if (moment(end) <= moment(start)) {
				this.flashMessagesService.show("Período inválido! A data inicial não pode ser maior ou igual que a data final", { cssClass: 'alert-danger', timeout: 6000 });
				return false;
			}
		} else {
			start = moment().subtract(this.period, 'hours').format("YYYY-MM-DD HH:mm:ss");
			end = this.today;
			this.selectedPeriod = "Últimas " + this.period + " horas";
		}

		dates = {
			dataInicio: start,
			dataFim: end
		}

		if (exportExcel) {
			this.exportErrorMessage(dates);
		}
		else {
			this.getVolumes(dates);
			this.getErrorMessages(dates);

			this.monitorService.getPeriod(dates).subscribe(result => {
				if (result.Success) {
					console.log("por periodo", result.Result);

					let graphData = [['Data', 'Tempo', 'DRS']];

					if (result.Result.length > 0) {
						result.Result.forEach(element => {
							let date;

							if (Number(this.period) === 0 && moment(end).diff(moment(start), 'hours', true) > 24) {
								date = moment(element.DataHora).format("DD/MM/YYYY");
							} else {
								date = moment(element.DataHora).format("HH:mm");
							}

							graphData.push([date, element.TempoMedioEmMinutos, element.DivisoesProcessadas]);
						});

						console.log("graphData", graphData);

						this.tableChartData = Object.create(this.tableChartData);
						this.tableChartData.dataTable = graphData;
					} else {
						this.tableChartData.dataTable = [];
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	exportErrorMessage(dates) {
		this.monitorService.getErrorMessagesExcel(dates).subscribe(blob => {
			if (blob) {
				let fileName = Number(this.period) > 0 ? "Ultimas" + this.period + "horas" : "PeriodoEspecifico";
				console.log("filename", fileName);
				saveAs(blob, "UltimasMensagens" + fileName + ".xlsx");
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getVolumes(dates) {
		this.monitorService.getVolumes(dates).subscribe(result => {
			if (result.Success) {
				console.log("volumes", result.Result);
				this.volumes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getErrorMessages(dates) {
		this.monitorService.getErrorMessages(dates).subscribe(result => {
			if (result.Success) {
				console.log("mensagens de erro", result.Result);
				this.errorMessages = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	searchByOv(exportExcel: boolean) {

		let dates = {
			ordemVenda: this.ovNumber,
			dataInicio: this.ovPeriodStart ? this.ovPeriodStart['date']['year'] + "-" + this.ovPeriodStart['date']['month'] + "-" + this.ovPeriodStart['date']['day'] + " 00:00:00" : null,
			dataFim: this.ovPeriodEnd ? this.ovPeriodEnd['date']['year'] + "-" + this.ovPeriodEnd['date']['month'] + "-" + this.ovPeriodEnd['date']['day'] + " 00:00:00" : null
		}

		if (moment(dates.dataFim) < moment(dates.dataInicio)) {
			this.flashMessagesService.show("Período inválido! A data inicial não pode ser maior que a data final", { cssClass: 'alert-danger', timeout: 6000 });
			return false;
		}

		// Pega a 00:00 da data inicio e a 23:59 da data fim
		dates.dataInicio = dates.dataInicio ? moment(dates.dataInicio).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;
		dates.dataFim = dates.dataFim ? moment(dates.dataFim).endOf('day').format("YYYY-MM-DD HH:mm:ss") : null;

		console.log("Dates da OV", dates);

		if (exportExcel) {
			this.exportByOV(dates);
		} else {
			this.getByOv("notificações", dates);
			this.getByOv("envios", dates);
			this.getByOv("mensagens", dates);
		}
	}

	exportByOV(dates) {
		this.monitorService.getByOvExcel(dates).subscribe(blob => {
			if (blob) {
				saveAs(blob, dates.ordemVenda + ".xlsx");
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getByOv(type, dates) {
		this.monitorService.getByOv(dates, type).subscribe(result => {
			if (result.Success) {
				console.log("By OV" + type, result.Result);

				if (type === 'notificações')
					this.ovNotifications = result.Result;

				if (type === 'envios')
					this.ovSend = result.Result;

				if (type === 'mensagens')
					this.ovErrorMessages = result.Result;

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	refreshPage() {
		this.getStatus();
		this.getQuantitys();
		this.getByPeriod(false);
	}

	setAutomaticRefresh(key) {
		if (key) {
			if (this.timerSubscription) {
				this.timerSubscription.unsubscribe();
			}
			this.timerSubscription = this.timer.subscribe(() => {
				this.refreshPage();
			});
		} else {
			if (this.timerSubscription) {
				this.timerSubscription.unsubscribe();
			}
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/monitor/component/monitor.component.ts